var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPeopleMd = function SvgPeopleMd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M19 21h4v-4.323a1 1 0 0 0-.629-.928l-3.742-1.5a1 1 0 0 1-.629-.926v-.878A3.98 3.98 0 0 0 20 9V7a4 4 0 0 0-6-3.465M14.371 16.749l-3.742-1.5a1 1 0 0 1-.629-.926v-.878A3.98 3.98 0 0 0 12 10V8a4 4 0 1 0-8 0v2a3.98 3.98 0 0 0 2 3.445v.878a1 1 0 0 1-.629.928l-3.742 1.5a1 1 0 0 0-.629.926V21h14v-3.323a1 1 0 0 0-.629-.928"
  })));
};
export default SvgPeopleMd;